
export enum VisitOnTimeStatus {
    Early,
    OnTime,
    Late,
    Missed
}
